<div class="gate-wrap">
  <div class="gate-card">
    <h2 class="mb-2">Site Access</h2>
    <p class="text-muted mb-3">
      Public registration is currently closed. Enter an invite code, or the email of an existing account, to continue to login.
    </p>

    <ul class="nav nav-tabs mb-3">
      <li class="nav-item">
        <button type="button" class="nav-link" [class.active]="mode === 'invite'" (click)="setMode('invite')">Invite code</button>
      </li>
      <li class="nav-item">
        <button type="button" class="nav-link" [class.active]="mode === 'email'" (click)="setMode('email')">Existing email</button>
      </li>
    </ul>

    <div *ngIf="mode === 'invite'" class="mb-3">
      <label class="form-label">Invite code</label>
      <input class="form-control" type="text" [(ngModel)]="inviteCode" (keyup.enter)="submit()" autocomplete="off" />
    </div>

    <div *ngIf="mode === 'email'" class="mb-3">
      <label class="form-label">Account email</label>
      <input class="form-control" type="email" [(ngModel)]="email" (keyup.enter)="submit()" autocomplete="username" />
    </div>

    <div class="text-danger mb-3" *ngIf="errorMessage">{{ errorMessage }}</div>

    <button type="button" class="btn btn-primary w-100" (click)="submit()" [disabled]="submitting">
      {{ submitting ? 'Checking…' : 'Continue' }}
    </button>
  </div>
</div>
